"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryListStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
const mobx_persist_1 = require("mobx-persist");
class InventoryListStore {
    constructor() {
        this.inventory = { value: [] };
        this.inventoryFormatted = { value: [] };
        this.inventoryFormattedOrig = { value: [] };
        this.showLoader = false;
        this.inventories = { value: [] };
        this.inventoryGroups = { value: [] };
        this.activePharm = 0;
        this.currentActiveSiteSelected = null;
        this.inventorySiteLots = {
            value: [],
            error: ""
        };
        this.fetchInventorySite = async (query) => {
            const response = await api_1.InventoryEndpoint.fetchInventorySite.apiCall({
                query
            });
            if (api_1.isError(response)) {
                console.error("Error in fetching inventorysite", response.code);
                return null;
            }
            return response.inventorysite;
        };
        this.loadAllInventories = async (query = { count: 500, start: 0 } // At some point count needs to be reconfigured.
        ) => {
            this.inventories.loading = true;
            const result = await api_1.InventoryEndpoint.listallinventories.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.inventories = { error: result.code };
            }
            else {
                this.inventories = { value: result.inventories };
            }
        };
        this.loadInventory = async (query = { start: 0, count: 100, order: "ASC", sort: "package" }) => {
            this.inventory.loading = true;
            this.inventoryFormatted.value = [];
            this.inventoryFormattedOrig.value = [];
            console.time("list");
            const result = await api_1.InventoryEndpoint.list.apiCall({
                query
            });
            console.timeEnd("list");
            // console.log("result in load inventory list:", result);
            if (api_1.isError(result)) {
                this.showLoader = false;
                this.inventory = { error: result.code };
                this.inventoryFormatted = { error: result.code };
                this.inventoryFormattedOrig = { error: result.code };
            }
            else {
                this.showLoader = false;
                this.inventory = { value: result.inventorylist };
                this.inventoryFormatted = { value: result.inventoryListFormatted };
                this.inventoryFormattedOrig = { value: result.inventoryListFormatted };
            }
        };
        this.loadInventoryGroup = async (query = { start: 0, count: 100 }) => {
            console.time("listgroup");
            const result = await api_1.InventoryEndpoint.listgroup.apiCall({
                query
            });
            console.timeEnd("listgroup");
            if (api_1.isError(result)) {
                this.inventoryGroups = { error: result.code };
            }
            else {
                this.inventoryGroups = { value: result.inventorylist };
            }
        };
        /**
         * save the group to inventory-group
         */
        this.createInventoryGroup = async (group) => {
            this.inventory.loading = true;
            const result = await api_1.InventoryEndpoint.creategroup.apiCall(null, {
                group
            });
            if (api_1.isError(result)) {
                this.newInventoryGroup = { error: result.code };
                this.inventory.loading = false;
            }
            else {
                this.newInventoryGroup = { value: result.group };
                this.inventory.loading = false;
            }
        };
        this.saveInventoryGroup = async (newGroupText, group) => {
            this.inventory.loading = true;
            const result = await api_1.InventoryEndpoint.savegroup.apiCall(null, {
                newGroupText,
                group
            });
            if (api_1.isError(result)) {
                this.newInventoryGroup = { error: result.code };
                this.inventory.loading = false;
            }
            else {
                this.newInventoryGroup = { value: result.group };
                this.inventory.loading = false;
            }
        };
        this.saveInventoryGroupMapped = async (groups) => {
            this.inventory.loading = true;
            console.time("saveInventoryGroupMapped");
            const result = await api_1.InventoryEndpoint.savegroupmapped.apiCall(null, {
                groups
            });
            console.timeEnd("saveInventoryGroupMapped");
            if (api_1.isError(result)) {
                console.error("Error in saving inventory group mapped");
            }
            else {
                console.info("Inventory group saved");
            }
            this.inventory.loading = false;
        };
        this.removeInventoryGroup = async (group) => {
            this.inventory.loading = true;
            const result = await api_1.InventoryEndpoint.removegroup.apiCall(null, {
                group
            });
            if (api_1.isError(result)) {
                this.inventory.loading = false;
                throw new Error("Error in removeInventoryGroup");
            }
            else {
                await this.loadInventoryGroup();
                this.inventoryGroupRemoved = result;
                this.inventoryGroups.value = this.inventoryGroups.value.filter((g) => g.group !== group);
                this.inventory.loading = false;
            }
        };
        this.loadInventorySiteLots = async (query) => {
            const result = await api_1.InventoryEndpoint.listinventorysitelots.apiCall({
                query
            });
            if (api_1.isError(result)) {
                alert("error in loading inventory Site Lots; check web console");
                console.error("error from load invenotry site lots is ", result.code);
                this.inventorySiteLots = { error: result.code };
            }
            else {
                this.inventorySiteLots = { value: result.inventorySiteLots };
            }
        };
        this.addInventorySiteLot = async (newLotMeta) => {
            const result = await api_1.InventoryEndpoint.addinventorysitelot.apiCall(null, {
                newLotMeta
            });
            if (api_1.isError(result)) {
                alert("error in adding inventory Site Lots; check web console");
                console.error("error from add invenotry site lots is ", result.code);
                return null;
            }
            return result.inventorySiteLot;
        };
        this.updateInventorySiteLotFromBarcode = async (newLotMeta) => {
            const result = await api_1.InventoryEndpoint.updateinventorysitelotfrombarcode.apiCall(null, {
                newLotMeta
            });
            if (api_1.isError(result)) {
                console.error("Error in updateInventorySiteLotFromBarcode", result.code);
            }
        };
        this.removeInventorySiteLot = async (lot) => {
            const result = await api_1.InventoryEndpoint.removeinventorysitelot.apiCall(null, {
                lot
            });
            if (api_1.isError(result)) {
                alert("error in removing inventory Site Lots; check web console");
                console.error("error from remove invenotry site lots is ", result.code);
            }
            else {
                // placeholder
            }
        };
        this.updateInventorySiteLots = async (site, inventoryMetas) => {
            await api_1.InventoryEndpoint.updateinventorysitelots.apiCall(null, {
                site,
                inventoryMetas
            });
        };
        this.updateInventorySiteActive = async (invIds, siteId) => {
            const result = await api_1.InventoryEndpoint.updateInventorySiteActive.apiCall(null, {
                siteId,
                invIds
            });
            if (api_1.isError(result)) {
                return { error: result.code, success: false };
            }
            return { success: true };
        };
        this.saveInventorySiteLots = async (lots, purchaseOrder) => {
            await api_1.InventoryEndpoint.saveinventorysitelots.apiCall(null, {
                lots,
                purchaseOrder
            });
        };
        this.updatePoInventoryAndSiteInventory = async (poInventory, batchQtyReceived, purchaseOrderId) => {
            await api_1.InventoryEndpoint.updatepoinventoryandsiteinventory.apiCall(null, {
                poInventory,
                batchQtyReceived,
                purchaseOrderId
            });
        };
    }
}
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "inventory", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "inventoryFormatted", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "inventoryFormattedOrig", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "showLoader", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "inventories", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "inventoryGroups", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "newInventoryGroup", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "inventoryGroupRemoved", void 0);
__decorate([
    mobx_persist_1.persist("object"),
    mobx_1.observable
], InventoryListStore.prototype, "activePharm", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "currentActiveSiteSelected", void 0);
__decorate([
    mobx_1.observable
], InventoryListStore.prototype, "inventorySiteLots", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "fetchInventorySite", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "loadAllInventories", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "loadInventory", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "loadInventoryGroup", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "createInventoryGroup", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "saveInventoryGroup", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "saveInventoryGroupMapped", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "removeInventoryGroup", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "loadInventorySiteLots", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "addInventorySiteLot", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "updateInventorySiteLotFromBarcode", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "removeInventorySiteLot", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "updateInventorySiteLots", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "updateInventorySiteActive", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "saveInventorySiteLots", void 0);
__decorate([
    mobx_1.action
], InventoryListStore.prototype, "updatePoInventoryAndSiteInventory", void 0);
exports.inventoryListStore = new InventoryListStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-list/store.ts
// module id = 169
// module chunks = 0